import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4db4876a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fw-bold mb-3 text-center d-flex justify-content-center title" }
const _hoisted_2 = { class: "row container shadow-lg bg-white p-3 p-lg-5 rounded-4 mx-auto mb-5" }
const _hoisted_3 = { class: "title-form fw-bold text-center pb-5 fs-6" }
const _hoisted_4 = { class: "information-container" }
const _hoisted_5 = { class: "d-flex pb-4" }
const _hoisted_6 = { class: "col-sm-3 fw-bold col-4" }
const _hoisted_7 = { class: "d-flex justify-content-center pb-4" }
const _hoisted_8 = { class: "col-sm-3 fw-bold col-4" }
const _hoisted_9 = { class: "col-sm-3 col-4" }
const _hoisted_10 = { class: "col-sm-6 col-4" }
const _hoisted_11 = { class: "d-flex justify-content-center pb-4" }
const _hoisted_12 = { class: "col-sm-3 fw-bold col-4" }
const _hoisted_13 = { class: "col-sm-3 col-4" }
const _hoisted_14 = { class: "col-sm-6 col-4" }
const _hoisted_15 = { class: "d-flex justify-content-center pb-4" }
const _hoisted_16 = { class: "col-3 fw-bold" }
const _hoisted_17 = { class: "col-9" }
const _hoisted_18 = { class: "d-sm-flex justify-content-center" }
const _hoisted_19 = { class: "col-sm-3 fw-bold" }
const _hoisted_20 = { class: "col-sm-9 text-break" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = { class: "d-flex justify-content-center pb-4" }
const _hoisted_23 = { class: "col-3 fw-bold" }
const _hoisted_24 = { class: "col-9" }
const _hoisted_25 = { class: "bg-white shadow rounded-4 p-3 p-lg-5 mb-3 container mb-lg-5" }
const _hoisted_26 = { class: "fw-bold fs-6" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_29 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_30 = { class: "fw-bold mb-3 text-center title" }
const _hoisted_31 = { class: "row mx-0 shadow-lg bg-white p-3 p-lg-5 rounded-4 mx-auto" }
const _hoisted_32 = { class: "mb-5" }
const _hoisted_33 = { class: "row mx-0 px-0 gx-3 mb-3" }
const _hoisted_34 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_35 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_36 = { class: "w-max-content col-lg-2" }
const _hoisted_37 = { class: "d-flex mx-0 px-0 col-lg-10" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode()
const _hoisted_39 = { class: "ms-3" }
const _hoisted_40 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_41 = { class: "w-max-content col-lg-2" }
const _hoisted_42 = { class: "d-flex mx-0 px-0 col-lg-10" }
const _hoisted_43 = { class: "ms-3" }
const _hoisted_44 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_45 = { class: "w-max-content col-lg-2" }
const _hoisted_46 = { class: "mx-0 px-0 col-lg-9" }
const _hoisted_47 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_48 = { class: "w-max-content col-lg-2" }
const _hoisted_49 = { class: "mx-0 px-0 col-lg-9" }
const _hoisted_50 = { class: "text-break" }
const _hoisted_51 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2" }
const _hoisted_52 = { class: "w-max-content col-lg-2" }
const _hoisted_53 = { class: "col-lg-8 mx-0 px-0" }
const _hoisted_54 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2" }
const _hoisted_55 = { class: "w-max-content col-lg-2" }
const _hoisted_56 = { class: "col-lg-8 mx-0 px-0" }
const _hoisted_57 = { class: "row mx-0 px-0 gx-3 mb-3" }
const _hoisted_58 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_59 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_60 = { class: "w-max-content col-lg-2" }
const _hoisted_61 = { class: "mx-0 px-0 col-lg-4" }
const _hoisted_62 = { class: "inputPass p-0" }
const _hoisted_63 = { class: "row mx-0 px-0 gx-3 mb-3" }
const _hoisted_64 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_65 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_66 = { class: "w-max-content col-lg-2" }
const _hoisted_67 = { class: "mx-0 px-0 col-lg-4" }
const _hoisted_68 = { class: "text-break" }
const _hoisted_69 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_70 = { class: "w-max-content col-lg-2" }
const _hoisted_71 = { class: "mx-0 px-0 col-lg-4" }
const _hoisted_72 = {
  key: 0,
  class: "text-break"
}
const _hoisted_73 = {
  key: 1,
  class: "text-break"
}
const _hoisted_74 = { class: "bg-white shadow rounded-4 p-3 p-lg-5 mb-3 mt-5 mb-lg-5" }
const _hoisted_75 = { class: "fw-bold fs-6" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_79 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }

import { computed, watchEffect, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { useStore } from 'vuex'
import dayjs from 'dayjs'
import joinCommunityService from '@/services/joinCommunity.service'
import { USER_STORE } from '@/store/constants'
import { pick, omit } from 'lodash'
import { getCookie } from '@/utils'
import { PATH } from '@/constants'
import { AuthenMethodTypes } from '@/store/modules/register-alumnus'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()
const invited_code = getCookie('invited_code_employee')
const loadingButton = ref<boolean>(false)
const data = computed(() => store.getters[USER_STORE.GETTERS.JOIN_USER_VALUE])
const invitedCommunity = computed(() => store.getters[USER_STORE.GETTERS.INVITE_COMMUNITY])
const first_time = ref()
const termsYelloop = computed(() => store.getters[USER_STORE.GETTERS.TERMS_YELLOOP])
const termsCommunity = computed(() => store.getters[USER_STORE.GETTERS.TERMS_COMMUNITY])
const validateComunity = ref<string>('')
const checkSubmitFormUsers = localStorage.getItem('checkConfirm')

onMounted(() => {
  const path = PATH[`${route.path.split('/')[1]}`]

  if (getCookie(path.header) && getCookie(path?.pathName)) {
    first_time.value = false
  } else {
    first_time.value = true
  }
})

watchEffect(() => {
  if (!checkSubmitFormUsers) router.push('/community/join_users')
  window.addEventListener('unload', function () {
    localStorage.removeItem('checkConfirm')
  })
})
const backRegis = () => {
  router.push('/community/join_users')
  localStorage.removeItem('checkConfirm')
}
const transitComplete = async () => {
  loadingButton.value = true
  try {
    const response = await joinCommunityService.registerEmployeeApi({
      ...omit(data.value, ['confirmPassword', 'birthday']),
      ...pick(invitedCommunity.value, ['community_id', 'email']),
      invited_code: invited_code,
      birthday: dayjs(data.value?.birthday).format('YYYY/MM/DD'),
      version_of_yelloop: termsYelloop.value?.id,
      version_of_community: termsCommunity.value?.id,
      authentication_method: data.value.authentication_method === AuthenMethodTypes.EMAIL ? 2 : 1,
    })
    if (response.status === 200) {
      router.push('/community/join_users_finished')
      store.dispatch(USER_STORE.ACTIONS.SET_JOIN_USER_VALUE, {
        family_name: '',
        given_name: '',
        family_name_kana: '',
        given_name_kana: '',
        password: '',
        confirmPassword: '',
        secondary_password: '',
        birthday: new Date(),
        consent_of_yelloop: false,
        consent_of_community: false,
        authentication_method: AuthenMethodTypes.SMS,
      })
      setTimeout(() => {
        loadingButton.value = false
      }, 500)
    } else {
      // 2022/10/19 PhuongTT Show invalid URL message UAT#4632: SB21 SB24 (Ph2-R20221021)
      validateComunity.value = response?.response?.data?.data[0]?.message_code
      localStorage.setItem('validateComunity', validateComunity.value)
      // if (response?.response?.data?.data[0]?.message_code === 'ERROR_PARTICIPATED') {
      //   localStorage.setItem('userParticipant', true)
      // } else if (response?.response?.data?.data[0]?.message_code === 'VALIDATE_NUMBER_OF_USERS') {
      //   localStorage.setItem('userMax', true)
      // } else if (response?.response?.data?.data[0]?.message_code === 'VALIDATE_DUPLICATE') {
      //   //2022/09/14 CW-Phuong Fix for horizontal fixing#1: SB21 SB24
      //   localStorage.setItem('validateDuplicate', true)
      // } else if (response?.response?.data?.data[0]?.message_code === 'VALIDATE_COMUNITY_AND_ALUMUNAI_DUPLICATE') {
      //   localStorage.setItem('validateComunity', true)
      // } else {
      //   localStorage.setItem('registerFailed', true)
      // }
      if (response?.response?.status !== 403) {
        router.push('/community/join_users')
      }
    }
  } catch (error) {
    console.log(error)
  }

  localStorage.setItem('checkSubmit', true)
  localStorage.removeItem('checkConfirm')
}

const submitSecond = async () => {
  loadingButton.value = true
  try {
    const response = await joinCommunityService.registerAffiliations(invitedCommunity.value?.community_id, {
      invited_code: invited_code,
      version_of_yelloop: termsYelloop.value?.id,
      version_of_community: termsCommunity.value?.id,
      consent_of_yelloop: true,
      consent_of_community: true,
      community_id: invitedCommunity.value?.community_id,
    })
    if (response.status === 200) {
      router.push('/community/join_users_finished')
    } else {
      // 2022/10/19 PhuongTT Show invalid URL message UAT#4632: SB21 SB24 (Ph2-R20221021)
      validateComunity.value = response?.response?.data?.data[0]?.message_code
      localStorage.setItem('validateComunity', validateComunity.value)
      // if (response?.response?.data?.data[0]?.message_code === 'ERROR_PARTICIPATED') {
      //   localStorage.setItem('userParticipant', true)
      // } else if (response?.response?.data?.data[0]?.message_code === 'VALIDATE_NUMBER_OF_USERS') {
      //   localStorage.setItem('userMax', true)
      // } else if (response?.response?.data?.data[0]?.message_code === 'VALIDATE_DUPLICATE') {
      //   //2022/09/14 CW-Phuong Fix for horizontal fixing#1: SB21 SB24
      //   localStorage.setItem('validateDuplicate', true)
      // } else if (response?.response?.data?.data[0]?.message_code === 'VALIDATE_COMUNITY_AND_ALUMUNAI_DUPLICATE') {
      //   localStorage.setItem('validateComunity', true)
      // } else {
      //   localStorage.setItem('registerFailed', true)
      // }
      if (response?.response?.status !== 403) {
        router.push('/community/join_users')
      }
    }
    setTimeout(() => {
      loadingButton.value = false
    }, 500)
  } catch (error) {
    console.log(error)
  }

  localStorage.setItem('checkSubmit', true)
  localStorage.removeItem('checkConfirm')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!first_time.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "pt-3 pt-lg-5 pb-3 pb-lg-5",
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", null, _toDisplayString(_unref(invitedCommunity)?.corporation_name) + " " + _toDisplayString(_unref(invitedCommunity)?.community_name) + " " + _toDisplayString(_unref(translate)('SB23heading')), 1)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(translate)('SB24title')), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(translate)('SB23basicinformation')), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(translate)('nameKanji')), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(invitedCommunity)?.user?.family_name), 1),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(invitedCommunity)?.user?.given_name), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(translate)('nameKatakana')), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(invitedCommunity)?.user?.family_name_kana), 1),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(invitedCommunity)?.user?.given_name_kana), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(translate)('SB20belong')), 1),
                _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(invitedCommunity)?.department_name), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(translate)('email')), 1),
                _createElementVNode("p", _hoisted_20, [
                  _createTextVNode(_toDisplayString(_unref(invitedCommunity)?.email), 1),
                  _hoisted_21
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
                _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(invitedCommunity)?.user?.birthday), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("h1", _hoisted_26, _toDisplayString(_unref(translate)('consent')), 1),
            _createElementVNode("div", null, [
              _createElementVNode("p", null, _toDisplayString(_unref(invitedCommunity)?.community_name) + _toDisplayString(_unref(translate)('agreeLeaderShip')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(Button, {
                title: _unref(translate)('titleButtonEdit'),
                type: 'secondary',
                onClick: backRegis
              }, null, 8, ["title"])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(Button, {
                title: _unref(translate)('signUp'),
                loading: loadingButton.value,
                type: 'secondary',
                onClick: submitSecond,
                disabled: loadingButton.value
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ])
        ], 32))
      : _createCommentVNode("", true),
    (first_time.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "container pt-3 pt-lg-5 pb-3 pb-lg-5",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("p", null, _toDisplayString(_unref(invitedCommunity)?.corporation_name) + " " + _toDisplayString(_unref(invitedCommunity)?.community_name) + " " + _toDisplayString(_unref(translate)('SB20heading')), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("p", _hoisted_32, _toDisplayString(_unref(translate)('SB21title')), 1),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(translate)('basicInformation')), 1)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(translate)('nameKanji')), 1),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", null, _toDisplayString(_unref(data)?.family_name), 1),
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(data)?.given_name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(translate)('nameKatakana')), 1),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", null, _toDisplayString(_unref(data)?.family_name_kana), 1),
                _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(data)?.given_name_kana), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(translate)('SB20belong')), 1),
              _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(invitedCommunity)?.department_name), 1)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("label", _hoisted_48, _toDisplayString(_unref(translate)('email')), 1),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(invitedCommunity)?.email), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("label", _hoisted_52, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
              _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(dayjs)(_unref(data).birthday).format('YYYY年M月D日')), 1)
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("label", _hoisted_55, _toDisplayString(_unref(translate)('PhoneNumber')), 1),
              _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(data).phone_number_1) + "-" + _toDisplayString(_unref(data).phone_number_2) + "-" + _toDisplayString(_unref(data).phone_number_3), 1)
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("label", _hoisted_58, _toDisplayString(_unref(translate)('SA20passwordSecret')), 1)
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("label", _hoisted_60, _toDisplayString(_unref(translate)('password')), 1),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("span", _hoisted_62, _toDisplayString('*'.repeat(_unref(data).password.length)), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(translate)('hiddenPassword')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("label", _hoisted_64, _toDisplayString(_unref(translate)('twoFA')), 1)
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("label", _hoisted_66, _toDisplayString(_unref(translate)('method')), 1),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, _toDisplayString(_unref(data).authentication_method !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)('useSMS') : _unref(translate)('useEmail')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("label", _hoisted_70, _toDisplayString(_unref(data).authentication_method !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)('phone') : _unref(translate)('email')), 1),
              _createElementVNode("div", _hoisted_71, [
                (_unref(data).authentication_method !== _unref(AuthenMethodTypes).EMAIL)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_unref(data).phone_number_1) + "-" + _toDisplayString(_unref(data).phone_number_2) + "-" + _toDisplayString(_unref(data).phone_number_3), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(_unref(invitedCommunity)?.email), 1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("h1", _hoisted_75, _toDisplayString(_unref(translate)('consent')), 1),
            _createElementVNode("div", null, [
              (_unref(invitedCommunity)?.admin)
                ? (_openBlock(), _createElementBlock("p", _hoisted_76, _toDisplayString(_unref(translate)('SB20agreeTerm1')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", null, _toDisplayString(_unref(invitedCommunity)?.community_name) + _toDisplayString(_unref(translate)('agreeLeaderShip')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createVNode(Button, {
                title: _unref(translate)('titleButtonEdit'),
                type: 'secondary',
                onClick: backRegis
              }, null, 8, ["title"])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _createVNode(Button, {
                title: _unref(translate)('titleRegis'),
                type: 'secondary',
                loading: loadingButton.value,
                onClick: transitComplete,
                disabled: loadingButton.value
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ])
        ], 32))
      : _createCommentVNode("", true)
  ], 64))
}
}

})